import i18n from '@/i18n/i18n'

export const INVOICE_BASE = {
  PAPER: { name: i18n.t('InvoiceInquiry.PaperInvoices'), code: '0' },
  ELEC: { name: i18n.t('InvoiceInquiry.ElectronicInvoice'), code: '1' },
  ALL_ELEC: { name: i18n.t('InvoiceInquiry.FullElectronicInvoice'), code: '2' }
}
export const INVOICE_TYPE = {
  NORMAL: { name: i18n.t('InvoiceInquiry.GeneralInvoice'), code: '0' },
  SPEC: { name: i18n.t('InvoiceInquiry.SpecialInvoice'), code: '1' }
}
